<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <div class="title">基本信息</div>
      <el-form-item label="计划名称" prop="planName">
        <el-input
          style="width: 350px"
          maxlength="30"
          size="small"
          clearable
          class="mr10 ipt"
          @blur="checkPlanName"
          v-model.trim="ruleForm.planName"
          placeholder="请输入30字内的计划名称"
          :disabled="type === 'edit'"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标人群">
        <div v-if="row.planRangeName">{{ row.planRangeName }}</div>
        <div v-else-if="row.planType === 'tagGroup' && tagGroupName">
          {{ tagGroupName }}
        </div>
        <div v-else-if="!planType">
          {{ row.rangeName
          }}{{ row.groupType === "pregnant" ? "孕妇" : "宝宝" }}
        </div>
        <el-button
          type="primary"
          size="small"
          @click="showGroupList"
          v-if="planType === 'tagGroup'"
          >选择人群</el-button
        >
        <!-- <el-button type="text" size="small">+ 增加筛选</el-button> -->
        <!-- <el-scrollbar
          ref="scrollContainer"
          :vertical="false"
          wrap-style="height: 150px;"
        >
          <div style="color: #999" class="operating">
            筛选条件
            <ul style="padding-left: 10px">
              <li
                v-for="(v, i) in ruleForm.selectList"
                :key="i"
                class="flex"
                style="height: 40px"
              >
                <div class="steps">
                  <div class="steps-box"></div>
                </div>
                <div class="ml20">
                  {{ v.name }}
                </div>
              </li>
            </ul>
          </div>
        </el-scrollbar> -->
      </el-form-item>
      <!-- <el-form-item label="计划方式" v-if="false">
        <el-radio-group v-model="ruleForm.dateType">
          <el-radio label="targetDate">指定时间段</el-radio>
          <el-radio label="dingshi">定时计划</el-radio>
        </el-radio-group>
        <span class="form-tip">{{
          ruleForm.dateType === "targetDate"
            ? "人群中满足条件的新增客户，会自动收到营销通知。 "
            : " 在指定时间向计划人群发送营销通知。"
        }}</span>
        <div v-if="ruleForm.dateType === 'targetDate'">
          <div class="mb20">
            <el-form-item label="执行日期" prop="planTime">
              <el-date-picker
                style="width: 350px"
                v-model="ruleForm.planTime"
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                key="planTime"
                size="small"
                class="mr10"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="planTimeChange"
                :picker-options="pickerOptions"
                :disabled="type === 'edit'"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="mb20">
            <el-form-item label="数量限制" prop="beforePushDays">
              一个计划每人最多推送
              <el-input
                style="width: 100px"
                maxlength="25"
                size="small"
                clearable
                class="mr10 ipt"
                @input="filterGt0OrFixed0('beforePushDays')"
                @mousewheel.prevent.native
                v-model.trim="ruleForm.beforePushDays"
                placeholder=""
                :disabled="type === 'edit'"
              ></el-input
              >次消息
            </el-form-item>
          </div>
          <div class="mb20">
            <el-form-item label="通知时间" prop="sendTime">
              每天
              <el-select
                style="width: 170px"
                size="small"
                clearable
                placeholder="选择通知时间"
                v-model="ruleForm.sendTime"
                class="mr10"
                filterable
                :disabled="type === 'edit'"
              >
                <el-option
                  label="上午（10:00～12:00）"
                  value="morning"
                ></el-option>
                <el-option
                  label="下午（15:00～17:00）"
                  value="afternoon"
                ></el-option>
              </el-select>
              发送通知
            </el-form-item>
          </div>
        </div>
        <div v-if="ruleForm.dateType === 'dingshi'">
          <el-form-item label="执行时间" prop="beforePushDays">
            <el-date-picker
              v-model="ruleForm.beforePushDays"
              type="date"
              placeholder="请选择执行时间"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
            ></el-date-picker>
          </el-form-item>
          <div class="mt20 mb20">
            <el-form-item label="通知时间" prop="sendTime">
              每天
              <el-select
                style="width: 170px"
                size="small"
                clearable
                placeholder="选择通知时间"
                v-model="ruleForm.sendTime"
                class="mr10"
                filterable
                :disabled="type === 'edit'"
              >
                <el-option
                  label="上午（10:00～12:00）"
                  value="morning"
                ></el-option>
                <el-option
                  label="下午（15:00～17:00）"
                  value="afternoon"
                ></el-option>
              </el-select>
              发送通知
            </el-form-item>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item label="计划方式">
        <div class="mb20">
          <el-form-item label="执行日期" prop="planTime">
            <el-date-picker
              style="width: 350px"
              v-model="ruleForm.planTime"
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :disabled="type === 'edit'"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="mb20">
          <el-form-item label="数量限制" prop="beforePushDays">
            一个计划每人最多推送
            <el-input
              style="width: 100px"
              maxlength="25"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.beforePushDays"
              placeholder=""
              @input="filterGt0OrFixed0('beforePushDays')"
              @mousewheel.prevent.native
              :disabled="type === 'edit'"
            ></el-input
            >次消息
            <!-- <div class="form-tip" style="margin-left: 0">
              根据设置的时机提前或延后推送1条补货消息,最长不超过7天
            </div> -->
          </el-form-item>
        </div>
        <div class="mb20">
          <el-form-item label="通知时间" prop="sendTime">
            每天
            <el-select
              style="width: 170px"
              size="small"
              clearable
              placeholder="选择通知时间"
              v-model="ruleForm.sendTime"
              class="mr10"
              filterable
              :disabled="type === 'edit'"
            >
              <el-option
                label="上午（10:00～12:00）"
                value="morning"
              ></el-option>
              <el-option
                label="下午（15:00～17:00）"
                value="afternoon"
              ></el-option>
              <el-option label="晚上（21:00～23:00）" value="night"></el-option>
            </el-select>
            发送通知
          </el-form-item>
        </div>
      </el-form-item>
      <div class="title mb10">推送商品</div>
      <el-form-item label="推送商品">
        <el-radio-group v-model="ruleForm.pushGoodsType">
          <el-radio label="guess">推送猜你喜欢商品</el-radio>
          <el-radio label="target">指定商品</el-radio>
        </el-radio-group>
        <el-form-item
          prop="repurchaseSkuRel"
          v-if="ruleForm.pushGoodsType === 'guess'"
        >
          <!-- <div>
          共22条商品
          <el-button type="text" class="blue" size="small">查看详情</el-button>
        </div> -->
        </el-form-item>
        <el-form-item
          prop="repurchaseSkuRel"
          v-if="ruleForm.pushGoodsType === 'target'"
          style="margin-left: -100px"
        >
          <div>
            <el-button
              type="primary"
              size="small"
              @click="dialogVisibleGoods = true"
              >+ 选择商品</el-button
            >
            <el-table
              stripe
              border
              ref="btable"
              :data="ruleForm.repurchaseSkuRel"
              style="width: 100%"
              id="table"
              size="small"
              max-height="300"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                show-overflow-tooltip
                label="规格"
              >
                <template slot-scope="scope">
                  <div>
                    <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                    <span>{{ scope.row.specIdGroupName }}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
              header-align="center"
              align="center"
              prop="specBarCode"
              label="商品条码"
            >
            </el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    class="blue"
                    type="text"
                    @click="del(scope.$index, 'repurchaseSkuRel')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form-item>
      <div class="title mb10">权益礼包</div>
      <div>
        <el-button
          type="primary"
          size="small"
          @click="dialogVisibleCoupons = true"
          >+ 选择优惠券</el-button
        >
      </div>
      <el-form-item prop="couponSendRel" style="margin-left: -100px">
        <div>
          <div class="form-tip">
            优惠券将直接发放给客户，不需要领取，增加权益将有效提升转化
          </div>
          <el-table
            stripe
            border
            ref="btable"
            :data="ruleForm.couponSendRel"
            style="width: 100%"
            id="table"
            size="small"
            max-height="300"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="name"
              label="优惠券名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendWayTypeFormat"
              label="发放类型"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放时间"
              width="200"
            >
              <template slot-scope="scope">
                {{
                  `${scope.row.sendStartDate} ${
                    scope.row.sendStartTime.split(",")[0]
                  }`
                }}<br />
                至{{
                  `${scope.row.sendEndDate} ${
                    scope.row.sendEndTime.split(",")[0]
                  }`
                }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendNumFormat"
              label="发放数量"
            ></el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="del(scope.$index, 'couponSendRel')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <div class="title">消息通知</div>
      <el-form-item label="通知设置">
        <el-form-item prop="smsContent">
          <div>
            <el-checkbox v-model="ruleForm.sendSmsStatus"
              >发送短信通知</el-checkbox
            >
          </div>
          <div class="line-h22">[{{ msgStartName }}]</div>
          <el-input
            class=""
            type="textarea"
            style="width: 300px"
            placeholder="请输入短信内容（含签名和后缀）"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.smsContent"
            @input="phoneLength"
          >
          </el-input>
          <div>
            <el-checkbox
              @change="checkedChange"
              size="mini"
              v-model="ruleForm.linkOpenStatus"
              >短信结尾含购买页链接(占用20字)</el-checkbox
            >
          </div>
          <div class="line-h22 text-right">拒收请回复R</div>
          <div class="form-item-tip">
            *提示:发送内容为 [<span class="primary">{{
              contentLength * 1 + 6
            }}</span
            >]字 | 发送条数为 [<span class="primary">{{ contentRow }}</span
            >]条 | 每条短信按照 [70]个字计费 |
          </div>
          <div class="form-item-tip">企业签名:[{{ msgStartName }}]</div>
          <div class="form-item-tip">
            *营销短信格式:【签名】+内容+拒收请回复R
          </div>
        </el-form-item>

        <el-form-item prop="wxmsgRemarks">
          <div class="mt20">
            <el-checkbox v-model="ruleForm.sendWxmsgStatus"
              >发送微信通知</el-checkbox
            >
          </div>
          <el-input
            type="textarea"
            style="width: 300px"
            placeholder="请输入微信通知内容"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.wxmsgRemarks"
          >
          </el-input>
        </el-form-item>
      </el-form-item>
      <div class="title">计划异常提醒</div>
      <!-- <el-form-item label="通知设置" prop="dangerSend">
        <el-checkbox v-model="ruleForm.dangerSend">发送短信通知</el-checkbox>
      </el-form-item> -->
      <el-form-item label="接收手机号" prop="wrongSmsMobile">
        <el-input
          style="width: 200px"
          clearable
          v-model.trim="ruleForm.wrongSmsMobile"
          size="small"
          type="number"
          placeholder="请输入手机号"
        ></el-input>
        <span class="form-tip">请注意，短信通知将扣除店铺短信的条数</span>
      </el-form-item>
    </el-form>
    <div class="flex flex-center">
      <el-button
        type="primary"
        size="small"
        @click="showPreviewModal('ruleForm')"
        >预览并提交</el-button
      >
      <el-button size="small" type="info" @click="$router.back(-1)"
        >返回</el-button
      >
    </div>
    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisibleGoods"
      :radio="false"
      :enabelList="ruleForm.repurchaseSkuRel"
      @saveGoods="saveGoods"
      @close="dialogVisibleGoods = false"
    ></hm-filter-m-s-goods>
    <hm-activity-coupons
      :visible="dialogVisibleCoupons"
      :enabelList="ruleForm.couponSendRel"
      @close="dialogVisibleCoupons = false"
      @save="saveCoupons"
    >
    </hm-activity-coupons>
    <el-dialog
      title="预览消息推送计划"
      :close-on-click-modal="false"
      :visible.sync="dialogVisiblePreview"
      :width="
        ruleForm.sendSmsStatus && ruleForm.sendWxmsgStatus
          ? '1200px'
          : ruleForm.sendSmsStatus || ruleForm.sendWxmsgStatus
          ? '800px'
          : '500px'
      "
    >
      <div class="flex flex-around" style="height: 670px">
        <div class="p10 flex flex-column flex-between">
          <div style="line-height: 22px">
            <div class="flex mb10">
              <div class="preview-title">计划名称</div>
              <div>{{ ruleForm.planName }}</div>
            </div>
            <div class="flex mb10">
              <div class="preview-title">计划方式</div>
              <div>
                <div>
                  {{ ruleForm.planTime[0] }}至{{ ruleForm.planTime[1] }}
                </div>
                <div>
                  每人每天最多收到1条消息，
                  <br />
                  每天
                  <span v-if="ruleForm.sendTime === 'morning'"
                    >上午（10:00～12:00）</span
                  >
                  <span v-else-if="ruleForm.sendTime === 'afternoon'"
                    >下午（15:00～17:00）</span
                  >
                  <span v-else-if="ruleForm.sendTime === 'night'"
                    >晚上（21:00～23:00）</span
                  >
                  收到通知
                </div>
              </div>
            </div>
            <div class="flex mb10">
              <div class="preview-title">推送商品</div>
              <div v-if="ruleForm.pushGoodsType === 'guess'">
                已选择 猜你喜欢商品
              </div>
              <div v-else>
                已选择指定商品<span
                  v-if="
                    ruleForm.repurchaseSkuRel &&
                      ruleForm.repurchaseSkuRel.length
                  "
                  >{{ ruleForm.repurchaseSkuRel.length }}</span
                >条
              </div>
            </div>
            <!-- <div class="flex mb10">
              <div class="preview-title">关联商品</div>
              <div>已选择{{ ruleForm.repurchaseSkuRel.length }}条商品</div>
            </div> -->
            <div class="flex">
              <div class="preview-title">优惠权益</div>
              <div>
                已选择<span
                  v-if="ruleForm.couponSendRel && ruleForm.couponSendRel.length"
                  >{{ ruleForm.couponSendRel.length }}</span
                >条优惠券包
              </div>
            </div>
          </div>
          <div class="flex flex-center" style="margin-bottom: 40px">
            <el-button size="small" type="primary" @click="confirm"
              >确 认</el-button
            >
            <el-button
              size="small"
              type="info"
              @click="dialogVisiblePreview = false"
              >取 消</el-button
            >
          </div>
        </div>

        <div class=" phone-gbimg mr10" v-if="ruleForm.sendSmsStatus">
          <div class="msg-content">
            <div class="text-center">
              今天
              <span class="gray" v-if="ruleForm.sendTime === 'morning'">
                上午10:00
              </span>
              <span class="gray" v-else-if="ruleForm.sendTime === 'afternoon'">
                下午15:00
              </span>
              <span class="gray" v-else-if="ruleForm.sendTime === 'night'">
                晚上21:00
              </span>
            </div>
            <div>
              <div class="bubbleItem">
                <!--左侧的泡泡-->
                <span class="bubble leftBubble">
                  [{{ msgStartName }}] <br />
                  {{ ruleForm.smsContent }}
                  <span class="blue" v-if="ruleForm.linkOpenStatus"
                    >短信跳转链接</span
                  >
                  <br />
                  拒收请回复R
                  <span class="bottomLevel"></span>
                  <span class="topLevel"></span>
                </span>
              </div>
              <div v-if="!ruleForm.linkOpenStatus" class="no-url">
                提示:<br />
                短信消息中没有设置跳转链接,可能会造成用户无法通过链接直接购买的情况
              </div>
            </div>
          </div>
        </div>
        <div class=" wx-gbimg" v-if="ruleForm.sendWxmsgStatus">
          <div class="msg-content">
            <div class="text-center">
              今天
              <span class="gray">
                <span v-if="ruleForm.sendTime === 'morning'">上午10:00</span>
                <span v-else-if="ruleForm.sendTime === 'afternoon'"
                  >下午15:00</span
                >
                <span v-else-if="ruleForm.sendTime === 'night'">晚上21:00</span>
              </span>
            </div>
            <div class="wx-msg-box">
              <div class="wx-title flex item-center" style="color: #222">
                <div class="logo flex flex-center item-center mr10">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/bf06d026-b271-41cf-8d07-cf2e699c0301.png"
                    alt=""
                  />
                </div>
                禾苗小程序
              </div>

              <div class="wx-tip flex">活动开始提醒</div>
              <div class="mt20 mb10">
                <div class="flex" style="line-height: 34px">
                  <div class="mr10" style="width: 60px; color: #666">
                    商品名称
                  </div>
                  <div class="flex-1" style="color: #222">
                    xxxxxxxxxxxxxxxxxxx
                  </div>
                </div>
                <div class="flex">
                  <div class="mr10" style="width: 60px; color: #666">
                    温馨提示
                  </div>
                  <div class="flex-1" style="color: #222">
                    {{ ruleForm.wxmsgRemarks }}
                  </div>
                </div>
              </div>

              <!-- <div class="bubbleItems">
                <span class="bubble leftBubble">
                  {{ ruleForm.wxmsgRemarks }}
                  <span class="bottomLevel"></span>
                  <span class="topLevel"></span>
                </span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="短信发送提示"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleSmsContent"
      width="500px"
    >
      <div>
        短信消息中没有设置跳转链接,可能会造成用户无法通过链接直接购买的情况，是否继续发送?
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="
            dialogVisiblePreview = true;
            dialogVisibleSmsContent = false;
          "
          size="small"
          type="info"
          >短信不设置链接,继续发送</el-button
        >
        <el-button
          @click="dialogVisibleSmsContent = false"
          size="small"
          type="primary"
          >返回修改</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="选择人群"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGroupList"
      width="1000px"
    >
      <div class="flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="add"
            >新建人群</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchCondition.groupName"
            placeholder="请输入人群名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mt20">
        <el-table
          stripe
          border
          ref="table"
          :data="groupList"
          style="width: 100%"
          size="small"
          max-height="400"
          highlight-current-row
          @current-change="getCurrentRow"
        >
          <!-- <el-table-column label="选择客户分群" align="center" width="100">
          <template slot-scope="scope">
            <el-radio :label="scope.$index + 1" v-model="radio"
                      @change.native="getCurrentRow(scope.row)"></el-radio>
          </template>
        </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="人群名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="estimateNum"
            label="人群人数"
          >
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="groupListSubmit" size="small" type="primary"
          >确定</el-button
        >
        <el-button @click="groupListCancel" size="small" type="info"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { arrayUnique2 } from "@/utils/utils";
import { getLoginUser } from "@/utils/auth";
import HmActivityCoupons from "@/components/HmActivityCoupons";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import moment from "moment";

export default {
  components: { HmActivityCoupons, HmFilterMSGoods },
  data() {
    const planNameFunc = (rule, val, callback) => {
      if (this.checkNameFlag) {
        return callback(new Error("该名称已被使用"));
      }
      callback();
    };
    // const goodsListFunc = (rule, val, callback) => {
    //   if (!val.length) {
    //     return callback(new Error("请添加复购商品"));
    //   }
    //   callback();
    // };
    const relevanceGoodsFunc = (rule, val, callback) => {
      if (this.ruleForm.pushGoodsType === "target") {
        if (!val.length) {
          return callback(new Error("请添加关联商品"));
        }
      }

      callback();
    };
    const couponsListFunc = (rule, val, callback) => {
      // if (!val.length) {
      //   return callback(new Error("请添加优惠券"));
      // }
      callback();
    };
    const smsContentFunc = (rule, val, callback) => {
      if (this.ruleForm.sendSmsStatus) {
        if (val === "") {
          return callback(new Error("请输入短信内容"));
        }
      }

      callback();
    };
    const wxmsgRemarksFunc = (rule, val, callback) => {
      if (this.ruleForm.sendWxmsgStatus) {
        if (val === "") {
          return callback(new Error("请输入微信通知内容"));
        }
      }

      callback();
    };
    return {
      dialogVisibleSmsContent: false,
      type: this.$route.query.type,
      row: {},
      tempRow: {},
      dialogVisibleGoods: false,
      dialogVisiblePreview: false,
      contentRow: 0,
      contentLength: 0,
      msgStartName: "",
      dialogVisibleCoupons: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        shortcuts: [
          {
            text: "未来一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "未来两周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "未来一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "未来三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      rules: {
        planName: [
          {
            required: true,
            message: "请输入计划名称",
            trigger: "blur"
          },
          {
            required: true,
            validator: planNameFunc,
            trigger: "blur"
          }
        ],
        planTime: {
          required: true,
          message: "请选择执行日期",
          trigger: "blur"
        },
        beforePushDays: {
          required: true,
          message: "请填写数量限制",
          trigger: "blur"
        },
        sendTime: {
          required: true,
          message: "请选择通知时间",
          trigger: "blur"
        },
        // repurchaseSkuRel: [
        //   {
        //     required: true,
        //     validator: goodsListFunc
        //   }
        // ],
        couponSendRel: {
          required: false,
          validator: couponsListFunc
        },
        repurchaseSkuRel: {
          required: true,
          validator: relevanceGoodsFunc
        },
        smsContent: {
          validator: smsContentFunc
        },
        wxmsgRemarks: {
          validator: wxmsgRemarksFunc
        },
        wrongSmsMobile: {
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }
      },
      tagGroupId: "",
      ruleForm: {
        planName: "",
        planTime: "",
        pushGoodsType: "target",
        beforePushDays: "1",
        sendTime: "morning",
        selectList: [
          {
            name: "性别",
            typeList: [{}, {}]
          },
          {
            name: "PLUS会员",
            typeList: [{}, {}]
          }
        ],
        repurchaseSkuRel: [],
        // repurchaseSkuRel: [],
        couponSendRel: [],
        sendSmsStatus: false,
        smsContent: "",
        linkOpenStatus: false,
        sendWxmsgStatus: false,
        wxmsgRemarks: "",
        wrongSmsMobile: "",
        planType: "ageGroup"
      },
      checkNameFlag: false,
      groupList: [],
      planType: "",
      dialogVisibleGroupList: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tagGroupName: "",
      searchCondition: {
        groupName: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.query.groupId) {
      this.ruleForm.planName =
        this.$route.query.groupName +
        "消息推送计划 " +
        moment(new Date()).format("YYYY-MM-DD");
      this.row.planRangeName = this.$route.query.groupName;
    }
    if (this.$route.query.planType) {
      this.planType = this.$route.query.planType;
      this.queryGroupList();
    }
  },
  mounted() {
    if (this.$route.query.row) {
      this.row = JSON.parse(this.$route.query.row);
    }
    this.queryMsgName().then(() => {
      if (this.type === "edit") {
        this.queryDetails();
      } else {
        if (getLoginUser().phone) {
          this.ruleForm.wrongSmsMobile = getLoginUser().phone || "";
        }
        this.ruleForm.planName =
          "生理轴消息推送计划 " + moment(new Date()).format("YYYY-MM-DD");
      }
    });
  },
  methods: {
    checkedChange(val) {
      if (val) {
        this.contentLength = this.contentLength * 1 + 20;
      } else {
        this.contentLength = this.contentLength * 1 - 20;
      }
      this.contentRow = Math.ceil((this.contentLength + 6) / 70);
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryStoreRepurchasePlanDetails",
        {
          id: this.row.id
        }
      );
      if (code === "0") {
        this.tagGroupName = result.tagGroupName;
        result.sendSmsStatus = result.sendSmsStatus === "yes" ? true : false;
        result.sendWxmsgStatus =
          result.sendWxmsgStatus === "yes" ? true : false;
        result.wrongSmsStatus = result.wrongSmsMobile.length > 0 ? "yes" : "no";
        result.linkOpenStatus = result.linkOpenStatus === "open" ? true : false;
        let length = result.smsContent.length + this.msgStartName.length;

        if (result.linkOpenStatus) {
          length = length * 1 + 20;
        }
        this.contentLength = length;
        this.contentRow = Math.ceil((length + 6) / 70);

        result.couponSendRel.forEach(v => {
          if (v.event === "luckyDraw") {
            v.sendNumFormat = "不限量";
          } else {
            v.sendNumFormat =
              v.sendNum === 9999999 || v.sendWayType === 1
                ? "不限量"
                : v.sendNum;
          }
          switch (v.sendWayType) {
            case 0:
              v.sendWayTypeFormat = "自动发放";
              break;
            case 1:
              v.sendWayTypeFormat = "手动发放";
              break;
            case 2:
              v.sendWayTypeFormat = "自助领券";
              break;
            case 3:
              v.sendWayTypeFormat = "兑换码领取";
              break;
            case 4:
              v.sendWayTypeFormat = "活动发放";
              break;
            case 5:
              v.sendWayTypeFormat = "内测发券";
              break;
            default:
              break;
          }
        });
        if (result.pushGoodsType === "guess") {
          result.repurchaseSkuRel = [];
        }
        result.planTime = [result.planStartDate, result.planEndDate];
        for (let key in result) {
          this.ruleForm[key] = result[key];
        }
      }
    },
    async confirm() {
      let params = JSON.parse(JSON.stringify(this.ruleForm));
      params.planStartDate = this.ruleForm.planTime[0];
      params.planEndDate = this.ruleForm.planTime[1];
      params.sendSmsStatus = this.ruleForm.sendSmsStatus ? "yes" : "no";
      params.sendWxmsgStatus = this.ruleForm.sendWxmsgStatus ? "yes" : "no";
      params.linkOpenStatus = this.ruleForm.linkOpenStatus ? "open" : "close";
      params.wrongSmsStatus =
        this.ruleForm.wrongSmsMobile.length > 0 ? "yes" : "no";
      if (this.$route.query.groupId) {
        params.tagGroupId = this.$route.query.groupId;
        params.planType = "tagGroup";
      }
      if (this.planType === "tagGroup") {
        params.tagGroupId = this.tagGroupId;
        params.planType = this.planType;
      }
      params.couponSendRel.forEach(v => {
        v.sendId = v.couponSendId;
      });
      if (this.type !== "edit") {
        params.targetId = this.row.id;
      }

      let name =
        this.type === "edit"
          ? "editStoreRepurchasePlan"
          : "saveStoreRepurchasePlan";
      const { code } = await this.$store.dispatch(name, params);

      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.back(-1);
      }
    },
    planTimeChange() {
      this.ruleForm.repurchaseSkuRel = [];
    },
    del(i, list) {
      this.ruleForm[list].splice(i, 1);
    },
    saveGoods(checkedRowList) {
      this.ruleForm.repurchaseSkuRel.push.apply(
        this.ruleForm.repurchaseSkuRel,
        checkedRowList
      );
      this.ruleForm.repurchaseSkuRel = arrayUnique2(
        this.ruleForm.repurchaseSkuRel,
        "wxshopSkuId"
      );
      this.dialogVisibleGoods = false;
    },
    phoneLength(val) {
      let length = val.length + this.msgStartName.length;
      if (this.ruleForm.linkOpenStatus) {
        length = length * 1 + 20;
      }
      this.contentLength = length;
      this.contentRow = Math.ceil((length + 6) / 70);
    },
    async queryMsgName() {
      const { result } = await this.$store.dispatch("querySmsSignature");
      this.msgStartName = result;
      this.contentLength = result.length;
      this.contentRow = Math.ceil((result.length + 6) / 70);
    },
    saveCoupons(checkedRowList) {
      this.ruleForm.couponSendRel.push.apply(
        this.ruleForm.couponSendRel,
        checkedRowList
      );
      this.ruleForm.couponSendRel = arrayUnique2(
        this.ruleForm.couponSendRel,
        "couponSendId"
      );
      this.dialogVisibleCoupons = false;
    },
    async checkPlanName() {
      if (this.ruleForm.planName !== "") {
        let params = {
          planType: "repurchase",
          planName: this.ruleForm.planName
        };
        const { code, result } = await this.$store.dispatch(
          "checkStoreRepurchasePlanName",
          params
        );
        if (code === "0") {
          this.checkNameFlag = !result;
          if (!result) {
            this.$message({
              message: "该名称已被使用！",
              type: "warning"
            });
          }
        }
      }
    },
    showPreviewModal(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.dialogVisiblePreview = true;
          if (this.ruleForm.sendSmsStatus && !this.ruleForm.linkOpenStatus) {
            this.dialogVisibleSmsContent = true;
          } else {
            if (this.planType === "tagGroup" && !this.tagGroupId) {
              this.$message({
                message: "请选择人群",
                type: "warning"
              });
              return;
            }
            this.dialogVisiblePreview = true;
          }
          //   this.$store.dispatch("addTurntable", params).then(res => {
          //     if (res.code === "0") {
          //       this.$message({
          //         message: "操作成功",
          //         type: "success"
          //       });
          //       this.$router.back(-1);
          //     }
          //   });
        } else {
          return false;
        }
      });
    },
    showGroupList() {
      this.dialogVisibleGroupList = true;
    },
    async queryGroupList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        groupName: this.searchCondition.groupName
      };
      const { result } = await this.$store.dispatch("tagGroupList", params);
      this.groupList = result.records;
      console.log(this.groupList);
      this.total = result.total;
    },
    groupListCancel() {
      this.dialogVisibleGroupList = false;
    },
    paging(page) {
      this.currentPage = page;
      this.queryGroupList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryGroupList();
    },
    getCurrentRow(row) {
      this.tempRow = row;
      console.log("this.tempRow:", this.tempRow);
    },
    groupListSubmit() {
      this.tagGroupId = this.tempRow.groupId;
      this.row.planRangeName = this.tempRow.groupName;
      this.dialogVisibleGroupList = false;
    },
    add() {
      this.$router.push({
        name: "AddPerson"
      });
    },
    search() {
      this.currentPage = 1;
      this.queryGroupList();
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: #222222;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.line-h22 {
  width: 300px;
  line-height: 22px;
}
.steps {
  border: 1px solid #d8d8d8;
  position: relative;
  .steps-box {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background: #ffffff;
    border: 1px solid #dddddd;
    left: -6px;
    bottom: 0px;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 1px;
      background: #dddddd;
      position: absolute;
      left: 3px;
      bottom: 4px;
    }
  }
}
// .sets-content {
//   position: relative;
//   div {
//     position: absolute;
//     bottom: 1;
//   }
// }
.preview-title {
  width: 70px;
  font-weight: bold;
}
.phone-gbimg {
  background: url("https://imgcdn.hemiao100.com/ThemePictures/0d421ec4ecc44e8dd0169a794a7720e.png")
    no-repeat center center;
  width: 367px;
}
.wx-gbimg {
  background: url("https://imgcdn.hemiao100.com/ThemePictures/e89b656214421560cf8a71ac4e933d5.png")
    no-repeat center center;
  .wx-msg-box {
    margin: 72px;
    padding: 10px;
    margin-top: 10px;
    background: #ffffff;
    .wx-title {
      padding: 10px;
      border-bottom: 2px solid #eee;
      .logo {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #e50065;
        img {
          width: 90%;
        }
      }
    }
    .wx-tip {
      font-size: 16px;
      font-weight: bold;
      color: #222;
      margin-top: 20px;
    }
  }
}
.msg-content {
  margin-top: 90px;
}
.bubbleItem {
  .bubble {
    max-width: 200px;
    position: relative;
    line-height: 20px;
    padding-left: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 7px;
    margin-top: 15px;
    padding-right: 10px;
    display: inline-block;
    color: #222;
  }
  .leftBubble {
    position: relative;
    margin-left: 40px;
    border: 1px solid #eee;
    background-color: #eee;
  }
  .leftBubble .bottomLevel {
    position: absolute;
    bottom: 6px;
    left: -10px;
    border-top: 10px solid #eee;
    border-left: 10px solid transparent;
  }
  .leftBubble .topLevel {
    position: absolute;
    bottom: 6px;
    left: -8px;
    border-top: 10px solid #eee;
    border-left: 10px solid transparent;
    z-index: 100;
  }
}
.bubbleItems {
  .bubble {
    max-width: 250px;
    position: relative;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 7px;
    margin-top: 15px;
    padding-right: 10px;
    display: inline-block;
    color: #222;
  }
  .leftBubble {
    position: relative;
    margin-left: 88px;
    border: 1px solid #fff;
    background-color: #fff;
  }
  .leftBubble .bottomLevel {
    position: absolute;
    top: 10px;
    left: -10px;
    border-top: 10px solid #fff;
    border-left: 10px solid transparent;
  }
  .leftBubble .topLevel {
    position: absolute;
    top: 11px;
    left: -8px;
    border-top: 10px solid #fff;
    border-left: 10px solid transparent;
    z-index: 100;
  }
}
.no-url {
  margin: 20px;
  padding: 20px;
  border: 1px solid wheat;
  color: red;
  border-radius: 11px;
  background: wheat;
}
</style>
